<template>
  <div
    class="fts-script-editor"
    :class="{'script-editor--disabled': disabled}"
  >
    <div class="script-editor-header">
      <div class="script-editor-label">
        <slot name="label">
          <div class="script-editor-default-label">{{label}}</div>
        </slot>
      </div>
      <div class="script-editor-lang">
        <div class="javascript" v-if="javascript">JavaScript</div>
        <div class="python" v-else-if="lang && lang.toLowerCase() === 'python'">Python</div>
        <div class="html" v-else>HTML</div>
      </div>
    </div>
    <div class="script-editor-wrapper" :id="editorId"></div>
  </div>
</template>
<script>
export default {
  props: {
    editorId: String,
    content: {
      type: String,
      default: ""
    },
    lang: {
      type: String,
      default: 'html'
    },
    label: String,
    disabled: Boolean
  },
  model: {
    prop: 'content',
    event: "update-content",
  },
  data: () => ({
    editor: null,
    beforeContent: "",
  }),
  computed: {
    javascript() {
      return this.lang && (this.lang.toLowerCase() === 'javascript' || this.lang.toLowerCase() === 'js')
    }
  },
  watch: {
    content(val) {
      if (this.beforeContent !== val) {
        this.editor && this.editor.setValue(val || "", 1);
      }
    },
  },
  mounted() {
    const lang = (this.lang || "html").toLowerCase();

    this.$nextTick(() => {
      this.editor = window.ace.edit(this.editorId, {
        autoScrollEditorIntoView: true,
        maxLines: 300,
        minLines: 10,
      });

      this.editor.setValue(this.content || "", 1);
      this.editor.getSession().setMode(`ace/mode/${lang}`);
      // this.editor.setTheme(`ace/theme/${theme}`);
      this.editor.setOption({
        autoScrollEditorIntoView: true,
        minLines: 10,
        maxLines: 300
      });

      if (this.disabled) {
        this.editor.setReadOnly(true);
      } else {
        this.editor.on("change", () => {
          this.beforeContent = this.editor.getValue();
          this.$emit("update-content", this.editor.getValue());
        });
      }
    })
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/vars.scss";

.fts-script-editor {
  &.script-editor--disabled {
    .script-editor-wrapper {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--fts-disabled);
        cursor: not-allowed;
        z-index: 10;
      }
      .ace_cursor {
        display: none;
      }
    }
  }
  .script-editor-header {
    display: flex;
    align-items: flex-end;
    .script-editor-label {
      flex: 1;
      .script-editor-default-label {
        margin-bottom: .175rem;
        font-size: 0.75rem;
        font-weight: 500;
      }
    }
    .script-editor-lang {
      div {
        padding: 1px 0.75rem;
        font-size: 0.675rem;  
        font-weight: 500; 
        display: inline-flex;
        &.html {
          background: rgb(228, 77, 38);
          color: #fff;
        }
        &.javascript {
          background: rgb(247, 223, 30);
          color: var(--fts-dark);
        }
        &.python {
          background: rgb(52, 115, 164);
          color: rgb(255, 211, 64);
        }
      }
    }
  }  
  .script-editor-wrapper {
    border: 1px solid var(--fts-gray-3);
  } 
}
</style>